import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const { user } = useAuth();
  const [balance, setBalance] = useState({ exists: true, record: null });
  const [lowStock, setLowStock] = useState([]);
  const [online, setOnline] = useState(navigator.onLine);

  const refreshBalance = useCallback(async () => {
    if (!user) return;
    const { data } = await api.get("/daily-balance/today");
    setBalance(data);
  }, [user]);

  const refreshLowStock = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/items/low-stock");
      setLowStock(data);
    } catch {}
  }, [user]);

  useEffect(() => {
    if (user) { refreshBalance(); refreshLowStock(); }
  }, [user, refreshBalance, refreshLowStock]);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  return (
    <AppContext.Provider value={{ balance, refreshBalance, lowStock, refreshLowStock, online, setOnline }}>
      {children}
    </AppContext.Provider>
  );
}
